import Swiper from '../../atoms/swiper'
import classNames from 'classnames'
import styles from './miniSimilarProducts.module.scss'
import { ProductCard } from '@src/quince-components/src'
import ProductCardDomain from '@src/quince-site-common/src/domains/ProductCard'

interface MiniSimilarProductsType {
  productCards: ProductCardDomain[]
}

function MiniSimilarProducts({ productCards }: MiniSimilarProductsType) {
  return (
    <Swiper
      className={styles.productList}
      slideClassName={styles.productListSlideClassName}
      numberOfVisibleSlides={3}
      variableWidth
      isVertical={true}
      showDots={false}
      isChevronIcon
      prevIconClass={classNames(styles.iconClass, styles.swiperPrevIcon)}
      nextIconClass={classNames(styles.iconClass, styles.swiperNextIcon)}
    >
      {productCards.map(pc => {
        const { product, selectedOptions } = pc
        return (
          <ProductCard
            key={ProductCardDomain.getProductCardIdentifier(pc)}
            selectedOptions={selectedOptions.length ? selectedOptions : undefined}
            className={styles.productCard}
            product={product}
            maxWidth={200}
            quality={100}
            hideReviews
            hideOptions
            hideProductName
            hideWishlistIcon
            hideBuyNowIcon
            hideTags
            productPriceClass={styles.productPrice}
            productPriceWrapperClass={styles.productPriceWrapper}
          />
        )
      })}
    </Swiper>
  )
}

export default MiniSimilarProducts
